import React from 'react'
import * as yup from "yup";

export const formSchema = yup.object().shape({
    email: yup.string().email("Invalid email format").required("Email is required"),
});